module.exports = __webpack_public_path__ + "img/麻栗坡县人民医院.01181c25.png";